export default __webpack_public_path__ + "static/media/check-mark.a1bc5c0b.svg";